// src/Presentation/Pages/MyOrders/OrdersList.tsx
import React from 'react';
import styles from './MyOrdersPage.module.css';

import type { IOrdersListProps } from '../../../Model/OrdersHistory.model';
import OrderCard from './OrderCard';

const OrdersList: React.FC<IOrdersListProps> = ({ orders, loading = false, apiError = null }) => {
  const showEmpty = !loading && !apiError && orders.length === 0;
  const showList = !loading && !apiError && orders.length > 0;

  return (
    <div className={styles.ordersList} data-testid="orders-list">
      {loading && (
        <div className={styles.loading} data-testid="orders-list-loading">
          Loading orders...
        </div>
      )}

      {!!apiError && (
        <div className={styles.error} data-testid="orders-list-error">
          {apiError}
        </div>
      )}

      {showEmpty && (
        <div className={styles.empty} data-testid="orders-list-empty">
          No orders found.
        </div>
      )}

      {showList && orders.map((o) => <OrderCard key={o.id} {...o} />)}
    </div>
  );
};

export default OrdersList;
